import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const AssistantContext = createContext(null);

export function AssistantProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [seedPrompt, setSeedPrompt] = useState('');

  const openAssistant = useCallback((prompt) => {
    if (prompt) setSeedPrompt(prompt);
    setOpen(true);
  }, []);

  const value = useMemo(
    () => ({ open, setOpen, openAssistant, seedPrompt, setSeedPrompt }),
    [open, openAssistant, seedPrompt],
  );

  return (
    <AssistantContext.Provider value={value}>
      {children}
    </AssistantContext.Provider>
  );
}

export function useAssistant() {
  return useContext(AssistantContext);
}
